var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66669 19.9997C6.66669 20.9163 7.41669 21.6663 8.33335 21.6663L33.3334 21.6663C34.25 21.6663 35 20.9163 35 19.9997C35 19.083 34.25 18.333 33.3334 18.333L8.33335 18.333C7.41669 18.333 6.66669 19.083 6.66669 19.9997ZM20 8.33301C20 9.24967 20.75 9.99967 21.6667 9.99967L33.3334 9.99967C34.25 9.99967 35 9.24967 35 8.33301C35 7.41634 34.25 6.66634 33.3334 6.66634L21.6667 6.66634C20.75 6.66634 20 7.41634 20 8.33301ZM15 33.333C14.0834 33.333 13.3334 32.583 13.3334 31.6663C13.3334 30.7497 14.0834 29.9997 15 29.9997L33.3334 29.9997C34.25 29.9997 35 30.7497 35 31.6663C35 32.583 34.25 33.333 33.3334 33.333L15 33.333Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_900_445",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 29,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66669 19.9997C6.66669 20.9163 7.41669 21.6663 8.33335 21.6663L33.3334 21.6663C34.25 21.6663 35 20.9163 35 19.9997C35 19.083 34.25 18.333 33.3334 18.333L8.33335 18.333C7.41669 18.333 6.66669 19.083 6.66669 19.9997ZM20 8.33301C20 9.24967 20.75 9.99967 21.6667 9.99967L33.3334 9.99967C34.25 9.99967 35 9.24967 35 8.33301C35 7.41634 34.25 6.66634 33.3334 6.66634L21.6667 6.66634C20.75 6.66634 20 7.41634 20 8.33301ZM15 33.333C14.0834 33.333 13.3334 32.583 13.3334 31.6663C13.3334 30.7497 14.0834 29.9997 15 29.9997L33.3334 29.9997C34.25 29.9997 35 30.7497 35 31.6663C35 32.583 34.25 33.333 33.3334 33.333L15 33.333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_900_445)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 40,
    height: 40,
    transform: "rotate(-90 0 40)",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.a8ddef19e60ef472b93c59e979710121.svg";
export { ForwardRef as ReactComponent };